define('controllers/consoleApi/myApi.detail.ctrl',['app'], function (app) {
    app.controller('myApiDetailCtrl', ['$scope', '$q', '$state', '$rootScope', 'ngDialog', '$stateParams', 'OpenApp', 'projectManageService', 'auiDialog', 'auiAgreementHelper', '$sce', 'reportUtil', 'ExportExcel',
        function ($scope, $q, $state, $rootScope, ngDialog, $stateParams, OpenApp, projectManageService, auiDialog, auiAgreementHelper, $sce, reportUtil, ExportExcel) {
            var Model = $scope.Model = {
                userInfo: $scope.Model.userInfo,
                isSelfPage: true,
                isCanShowByTeam: false,
                isShowReport: !AUI.HDGWCall.getUserInfoValue('teamid') && AUI.BaseJSUtil.contains(sysParamCfg.isShowApiReportApis, $stateParams.apiID),
                type: 'line',
                //流量次数报表
                requestTimesCharts: {
                    id: "myreport.request.times",
                    width: "100%",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                //错误报表
                errorTimesCharts: {
                    id: "myreport.error.times",
                    width: "100%",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                //平均时延报表
                averageDelayCharts: {
                    id: "myreport.may.delay",
                    width: "100%",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                query: {
                    day: 30
                }
            };
            var agreementArray = [];
            Model.projectKey = $stateParams.projectKey;
            Model.apiID = $stateParams.apiID;
            var agreementTypes = [];
            Model.signedAgreeList = [];
            if (!Model.apiID || Model.apiID == 0 || Model.projectKey == '0') {
                $state.go('myApi', {projectKey: Model.projectKey}, {reload: true});
            }
            Model.selectType = {
                request: 1,
                error: 2,
                maxDelay: 1
            };
            $scope.apiLimitShow = {0: '无', 1: '有'};
            projectManageService.setProjectKey(Model.projectKey);
            $scope.callback = callback;
            $scope.closeApi = closeApi;
            $scope.clickApi = clickApi;
            $scope.editApiKey = editApiKey;
            $scope.clickHref = clickHref;
            $scope.showAgreement = showAgreement;
            $scope.moreManager = moreManager;
            $scope.sortMethodSummaryListData = sortMethodSummaryListData;
            $scope.setReportType = setReportType;
            $scope.changeDateType = changeDateType;
            $scope.getReport = getReport;
            $scope.viewScopeList = viewScopeList;
            $scope.showMyScope = showMyScope;

            //$rootScope.checkState($state).then(function () {
            init();
            //})

            function init() {
                projectManageService.getProjectInfo({projectKey: Model.projectKey}).then(function (data) {
                    if (data && data.projectInfo) {
                        projectManageService.getProjectAPI(data.projectInfo.projectID).then(function (resp) {
                            if (AUI.BaseJSUtil.contains(resp.apiIDList, Model.apiID)) {
                                Model.myProject = data.projectInfo;
                                projectManageService.setProjectKey(Model.myProject.projectKey);
                                getApiList();
                                Model.isShowReport && getReportData();
                            } else {
                                $state.go('myApi', {projectKey: Model.projectKey}, {reload: true});
                            }
                        }).catch(function () {
                            $state.go('myApi', {projectKey: Model.projectKey}, {reload: true});
                        });
                    }
                });
            }

            function clickHref(url) {
                if (url) {
                    AUI.BaseJSUtil.redirectUrlByBlank(url);
                }
            }

            function callback() {
                $state.go('myApi', {projectKey: Model.projectKey});
            }

            function getApiList() {
                try {
                    projectManageService.getAPIDetail(Model.apiID).then(function (resp) {
                        Model.apiInfo = resp.apiDetail;
                        if (Model.apiInfo.langInfo && Model.apiInfo.langInfo.displayAttrs) {
                            Model.apiInfo.langInfo.displayAttrs = angular.fromJson(Model.apiInfo.langInfo.displayAttrs);
                            if (Model.apiInfo.langInfo.displayAttrs.moreAPIs && Model.apiInfo.langInfo.displayAttrs.moreAPIs.apiList && Model.apiInfo.langInfo.displayAttrs.moreAPIs.apiList.length > 0) {
                                projectManageService.getApiListByIds(Model.apiInfo.langInfo.displayAttrs.moreAPIs.apiList).then(function (apiInfoTileList) {
                                    Model.apiInfoTileList = apiInfoTileList;
                                })
                            }
                            if (Model.apiInfo.langInfo.displayAttrs && Model.apiInfo.langInfo.displayAttrs.serviceterms && Model.apiInfo.langInfo.displayAttrs.serviceterms.content && Model.apiInfo.langInfo.displayAttrs.serviceterms.content.length > 0) {
                                Model.apiInfo.langInfo.displayAttrs.serviceterms.content.forEach(function (agree) {
                                    if (agree.agreementType) {
                                        agreementTypes.push(agree.agreementType);
                                        agreementArray.push({agrType: agree.agreementType, country: 'cn', count: 1});
                                    }
                                });
                                projectManageService.getIsSignAgreement(agreementTypes).then(function (res) {
                                    if (res && res.signInfoList && res.signInfoList.length > 0) {
                                        res.signInfoList.forEach(function (signInfo) {
                                            if ((signInfo.signStatus == 1 || signInfo.signStatus == 2)) {
                                                Model.signedAgreeList.push(signInfo.agrType);
                                            }
                                        });
                                    }
                                });
                            }

                            auiAgreementHelper.checkAgreements(agreementArray, callback, $scope.Model.userInfo, true).then(function () {
                            });
                            if (Model.apiInfo.langInfo.displayAttrs.serviceCard && Model.apiInfo.langInfo.displayAttrs.serviceCard.serviceLinkUrl) {
                                //openAPP数据库写死的认为可信的
                                Model.serviceLinkUrl = $sce.trustAsResourceUrl(Model.apiInfo.langInfo.displayAttrs.serviceCard.serviceLinkUrl);
                                Model.isCanShowByTeam = !AUI.HDGWCall.getUserInfoValue('teamid')
                                    || (AUI.HDGWCall.getUserInfoValue('teamid') && (Model.apiInfo.langInfo.displayAttrs.serviceCard.teamMemberArea == 3 || Model.apiInfo.langInfo.displayAttrs.serviceCard.teamMemberArea == 2));
                            }
                        }
                    });
                } catch (e) {
                    console(e);
                }

            }


            function viewScopeList() {
                var defer = $q.defer();
                ngDialog.open({
                    template: 'pages/consoleApi/template/scope.list.html',
                    className: '',
                    replace: true,
                    controller: ['$scope', function ($scopeList) {
                        $scopeList.cancel = cancel;
                        $scopeList.selectAll = selectAll;
                        $scopeList.selectSingle = selectSingle;
                        $scopeList.doSubmit = doSubmit;
                        $scopeList.delSingleScope = delSingleScope;
                        $scopeList.showApplyScopes = showApplyScopes;
                        $scopeList.getScopeList = getScopeList;
                        $scopeList.scopeSenstiveFilter = {
                            '0': '公开',
                            '1': '敏感'
                        };
                        $scopeList.scopeStatusFilter = {
                            '0': '未开通',
                            '1': '已开通',
                            '2': '申请中'
                        };
                        function getScopeList() {
                            var projApiParams = {
                                req: {
                                    projectID: Model.myProject.projectID,
                                    apiID: Model.apiID,
                                    lang: 'zh_CN'
                                }
                            };
                            OpenApp.getProjApiScopeList(projApiParams).then(function (resp) {
                                if (resp && resp.resultCode == 0 && resp.userProjScopeList) {
                                    $scopeList.userProjScopeList = resp.userProjScopeList;
                                    $scopeList.availableCheckedList = [];
                                    if ($scopeList.userProjScopeList.length > 0) {
                                        $scopeList.userProjScopeList.forEach(function (userProjScope) {
                                            if (userProjScope.status == 0 || userProjScope.status == 3) {
                                                userProjScope.isChecked = false;
                                                $scopeList.availableCheckedList.push(userProjScope)
                                            }
                                        })
                                        $scopeList.isCheckedAll = false;
                                    }
                                    defer.resolve();
                                }
                            }).catch(function () {
                                defer.reject();
                            });
                        }
                        getScopeList();

                        function cancel() {
                            ngDialog.close();
                        }

                        function selectAll(event) {
                            event.stopPropagation();
                            if ($scopeList.isCheckedAll) {
                                $scopeList.userProjScopeList.forEach(function (userProjScope) {
                                    if (userProjScope.status == 0) {
                                        userProjScope.isChecked = false;
                                    }
                                });
                                $scopeList.isCheckedAll = false;
                            } else {
                                $scopeList.userProjScopeList.forEach(function (userProjScope) {
                                    if (userProjScope.status == 0) {
                                        userProjScope.isChecked = true;
                                    }
                                });
                                $scopeList.isCheckedAll = true;
                            }
                        }
                        function selectSingle(index, event, flag) {
                            event.stopPropagation();
                            if (flag) return;
                            if ($scopeList.userProjScopeList[index].isChecked) {
                                $scopeList.userProjScopeList[index].isChecked = false;
                            } else {
                                $scopeList.userProjScopeList[index].isChecked = true;
                            }
                            var isCheckedList = [];
                            $scopeList.userProjScopeList.forEach(function (userProjScope) {
                                if ((userProjScope.status == 0 || userProjScope.status == 3) && userProjScope.isChecked) {
                                    isCheckedList.push(1)
                                } else if ((userProjScope.status == 0 || userProjScope.status == 3) && !userProjScope.isChecked) {
                                    isCheckedList.push(0)
                                }
                            });
                            if (isCheckedList.indexOf(0) == '-1') {
                                $scopeList.isCheckedAll = true;
                            } else {
                                $scopeList.isCheckedAll = false;
                            }
                        }

                        //移出
                        function delSingleScope(row) {
                            if(row.status ==1){
                                var defer = $q.defer();
                                auiDialog.confirm('是否确认移出？', function () {
                                    var delScopeIDList = [];
                                    if (row) delScopeIDList.push(row.scopeID);

                                    var params = {
                                        req: {
                                            projectID: Model.myProject.projectID,
                                            apiID: Model.apiID,
                                            scopeIDList: delScopeIDList
                                        }
                                    };
                                    OpenApp.delProjScopeList(params).then(function () {
                                        auiDialog.success('移出成功', function () {
                                            getScopeList();
                                        });
                                        defer.resolve();
                                    }).catch(function () {
                                        getScopeList();
                                        defer.reject();
                                    });
                                }, function () {
                                    getScopeList();
                                    defer.reject();
                                });
                                return defer.promise;
                            }else{
                                return;
                            }

                        }

                        //敏感权限申请列表弹窗
                        function showApplyScopes() {
                             var dia = ngDialog.open({
                                template: 'pages/consoleApi/template/apply.sensitive.scope.html',
                                className: '',
                                replace: true,
                                controller: ['$scope', function ($scope) {
                                    $scope.Model = Model;
                                    $scope.cancelApply = cancelApply;
                                    Model.sensitiveScopeList.forEach(function (item) {
                                        item.applySco = '';
                                    });
                                    $scope.apiName = Model.apiInfo.langInfo.apiName;
                                    $scope.isGreenOrGray = function () {
                                        Model.applyDescList = [];
                                        Model.sensitiveScopeList.forEach(function (item) {
                                            if (item.applySco) {
                                                var sensitiveScopeItem = {};
                                                sensitiveScopeItem.scopeID = item.scopeID;
                                                sensitiveScopeItem.scopeUrl = item.scopeUrl;
                                                sensitiveScopeItem.applyReason = item.applySco;
                                                Model.applyDescList.push(sensitiveScopeItem)
                                            }
                                        });
                                        //控制提交按钮是否置灰
                                        return Model.applyDescList.length != Model.sensitiveScopeList.length;


                                    };
                                    $scope.submitSensitiveScope = submitSensitiveScope;
                                    //敏感权限提交申请
                                    function submitSensitiveScope() {
                                        if ($scope.isGreenOrGray()) return;
                                        var defer = $q.defer();
                                        var submitPrarms = {
                                            req: {
                                                projectID: Model.myProject.projectID,
                                                apiID: Model.apiID,
                                                applyScopes: Model.applyDescList
                                            }
                                        };
                                        OpenApp.applyProjScopeList(submitPrarms).then(function (res) {
                                            if (res.resultCode == 0) {
                                                auiDialog.success('敏感Scope开通申请提交成功', function () {
                                                    dia.close();
                                                    getScopeList();
                                                });
                                                defer.resolve();
                                            } else {
                                                defer.reject();
                                            }
                                        }).catch(function () {
                                            dia.close();
                                            getScopeList();
                                            defer.reject();
                                        });
                                        return defer.promise;
                                    }

                                    function cancelApply() {
                                        dia.close();
                                        getScopeList();
                                    }
                                }]
                            })
                        }


                        function doSubmit() {
                            var checkedScopesList = [];//被勾选的scope列表，包括公开和敏感
                            $scopeList.userProjScopeList.forEach(function (scopeItem) {
                                if (scopeItem.isChecked) checkedScopesList.push(scopeItem)
                            });
                            if (checkedScopesList.length == 0) {
                                return;
                            } else {
                                var publicScopeList = [];//被勾选的公开类型的scope
                                Model.sensitiveScopeList = [];//被勾选的敏感类型的scope
                                checkedScopesList.forEach(function (checkedItem) {
                                    if (checkedItem.senstive) {
                                        Model.sensitiveScopeList.push(checkedItem)
                                    } else {
                                        publicScopeList.push(checkedItem)
                                    }
                                });
                                if (publicScopeList.length > 0) {
                                    var defer = $q.defer();
                                    var publicScopeIdList = [];
                                    publicScopeList.forEach(function (item) {
                                        publicScopeIdList.push(item.scopeID)
                                    });
                                    var param = {
                                        req: {
                                            projectID: Model.myProject.projectID,
                                            apiID: Model.apiID,
                                            scopeIDList: publicScopeIdList
                                        }
                                    };
                                    OpenApp.addProjScopeList(param).then(function (data) {
                                            if (data.resultCode == 0) {
                                                defer.resolve();
                                                if (Model.sensitiveScopeList.length > 0) {
                                                    showApplyScopes();
                                                } else {
                                                    auiDialog.success('公共Scope开通成功', function () {
                                                        getScopeList();
                                                    })

                                                }
                                            } else {
                                                defer.reject();
                                            }
                                        }
                                    );
                                    return defer.promise;
                                } else if (Model.sensitiveScopeList.length > 0) {
                                    setTimeout(function () {
                                        showApplyScopes();
                                    }, 200);
                                }
                            }
                        }
                    }]
                });
                return defer.promise;
            }

            function showMyScope() {
                $state.go('myScope', {
                    projectKey: Model.myProject.projectKey,
                    projectID: Model.myProject.projectID
                }, {reload: true})
            }


            //编辑apiKey
            function editApiKey(row) {
                $state.go('apiKey', {
                    projectKey: Model.myProject.projectKey,
                    projectID: Model.myProject.projectID,
                    clientID: row.clientID
                }, {reload: true});
            }

            function closeApi() {
                auiDialog.confirm("权限关闭", "关闭API权限，API将无法使用，可能导致您应用异常，确定关闭吗？", function () {
                    projectManageService.delProjectAPI(Model.myProject.projectID, [Model.apiID]).then(function () {
                        $state.go('myApi', {projectKey: Model.projectKey});
                    });
                });
            }

            function clickApi(apiInfo) {
                $state.go('apiListDetail', {projectKey: Model.projectKey, apiID: apiInfo.langInfo.apiID});
            }

            function showAgreement() {
                var defer = $q.defer();
                auiAgreementHelper.viewAndDownloadAgreements(Model.signedAgreeList).then(function () {
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            //更多管理
            function moreManager() {
                Model.isSelfPage = false;
            }

            //设置响应码
            function setReportType(type, key) {
                Model.selectType[type] = key;
                if (type == 'request') {
                    //按照错误码查的流量
                    projectManageService.getApiMetricList(getReportParam(Model.selectType.request, Model.selectType.request == 1 ? 3 : 2)).then(function (data) {
                        showReport(data, 'requestTimesCharts', '流量')
                    });
                } else {
                    //按照错误码查的错误
                    projectManageService.getApiMetricList(getReportParam(Model.selectType.maxDelay, 1)).then(function (data) {
                        showReport(data, 'averageDelayCharts', '平均时延（ms）')
                    });
                }
            }

            function changeDateType(day) {
                if (Model.query.day != day) {
                    Model.query.day = day;
                    getReportData();
                }
            }

            function getReport() {
                getReportData();
            }

            //获取报表的数据
            //getApiMetricList getApiVersionList getMethodSummaryList
            function getReportData() {
                projectManageService.getApiIDToNameFilter().then(function (apiIDToNameFilter) {
                    Model.apiIDToNameFilter = apiIDToNameFilter;
                    //按照错误码查的流量
                    projectManageService.getApiMetricList(getReportParam(Model.selectType.request, Model.selectType.request == 1 ? 3 : 2)).then(function (data) {
                        showReport(data, 'requestTimesCharts', '流量')
                    }).catch(function (e) {
                        Model.requestTimesCharts.options = null;
                    });
                    //按照错误码查的时延
                    projectManageService.getApiMetricList(getReportParam(Model.selectType.error, 3)).then(function (data) {
                        showReport(data, 'errorTimesCharts', '错误数')
                    }).catch(function (e) {
                        Model.errorTimesCharts.options = null;
                    });
                    //按照错误码查的错误
                    projectManageService.getApiMetricList(getReportParam(Model.selectType.maxDelay, 1)).then(function (data) {
                        showReport(data, 'averageDelayCharts', '平均时延（ms）')
                    }).catch(function (e) {
                        Model.averageDelayCharts.options = null;
                    });
                    //获取版本的列表
                    projectManageService.getApiVersionList({apiID: Model.apiID}).then(function (data) {
                        Model.apiVersionList = data.apiVersionInfoList;
                    });
                    //获取方法的列表
                    projectManageService.getMethodSummaryList({
                        projectID: Model.myProject.projectID,
                        apiID: Model.apiID,
                        dataRanges: [{
                            dateType: 'day',
                            dateValue: Model.query.day
                        }]
                    }).then(function (data) {
                        Model.methodSummaryList = data;
                    })
                });


            }

            function sortMethodSummaryListData(type) {
                if (Model.methodSummaryList.length <= 1) return;
                if (isSort(type)) {
                    Model.methodSummaryList.sort(AUI.BaseJSUtil.arrObjCompare(type));
                    Model.methodSummaryList.reverse();
                } else {
                    Model.methodSummaryList.sort(AUI.BaseJSUtil.arrObjCompare(type));
                }
            }

            //判断正序
            function isSort(type) {
                return Model.methodSummaryList[1][type] >= Model.methodSummaryList[0][type];
            }


            function getReportParam(type, metric) {
                var req = {
                    projectID: Model.myProject.projectID,
                    apiID: Model.apiID,
                    type: type,
                    metric: metric,
                    dataRanges: [{
                        dateType: 'day',
                        dateValue: Model.query.day
                    }]
                }


                if (Model.methodSummarySelect && Model.methodSummarySelect.length > 0) {
                    var methodFilterList = [];
                    Model.methodSummarySelect.forEach(function (method) {
                        methodFilterList.push(method.name);
                    });
                    req.methodFilterList = angular.copy(methodFilterList);
                }
                if (Model.apiVersionSelect && Model.apiVersionSelect.length > 0) {
                    var versionFilterList = [];
                    Model.apiVersionSelect.forEach(function (version) {
                        versionFilterList.push(version.apiVersion);
                    })
                    req.versionFilterList = angular.copy(versionFilterList);
                }
                return req;
            }

            function showReport(data, type, name) {
                var requestResult = reportUtil.getXYFromBI(data.metricInfoListReport, "date", 1,
                    data.dimensionList);
                var series = [];
                data.dimensionList.forEach(function (dimension) {
                    series.push({
                        "name": dimension,
                        "type": Model.type,
                        "data": requestResult[dimension]
                    })
                });
                Model[type].options = projectManageService.getChartOptions(name, requestResult["date"], series);
                Model[type].options.toolbox.feature.myTool1 = {
                    show: true,
                    title: '下载',
                    icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
                    onclick: function () {
                        ExportExcel.data2Excel(data.metricInfoListData, name + '.xlsx', name)
                    }
                };
            }

        }
    ]);
});

